import { IAttribute, IModel, IViolation } from '../base/annotation';
import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { FormatDatasetV2 } from './dataset.v2';
import * as fileFormatConstants from '../../constants/fileformat-constants';
import { format } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';

@Metamodel.model({
    name: ModelConstants.delimitedTextDataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate, shellStringResources.ModelName_DelimitedTextDataset),
        format(shellStringResources.ModelName_DatasetsTemplate, shellStringResources.ModelName_DelimitedTextDataset)
    ]
})
export class DelimitedTextDataset extends FormatDatasetV2 {
    public static readonly MODEL: IModel;
    public static readonly COLUMN_DELIMITER: IAttribute;
    public static readonly ROW_DELIMITER: IAttribute;
    public static readonly ENCODING_NAME?: IAttribute;
    public static readonly COMPRESSION_CODEC?: IAttribute;
    public static readonly COMPRESSION_LEVEL?: IAttribute;
    public static readonly QUOTE_CHAR?: IAttribute;
    public static readonly ESCAPE_CHAR?: IAttribute;
    public static readonly CHARTOESCAPE_QUOTEESCAPING?: IAttribute;
    public static readonly FIRSTROW_ASHEADER?: IAttribute;
    public static readonly NULL_VALUE?: IAttribute;
    public static readonly MULTILINE?: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'COLUMN_DELIMITER',
        display: shellStringResources.ModelName_ColumnDelimiter,
        constraint: {
            validator: DelimitedTextDataset.validateColumnDelimiter
        }
    })
    public columnDelimiter?: string = ',';

    @Metamodel.attribute({
        templatable: true,
        association: 'ROW_DELIMITER',
        display: shellStringResources.Dataset_FileFormat_RowDelimiterFieldLabel
    })
    public rowDelimiter?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'ENCODING_NAME',
        display: shellStringResources.ModelName_Encoding
    })
    public encodingName?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'COMPRESSION_CODEC',
        display: shellStringResources.ModelName_CompressionCodec
    })
    public compressionCodec?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'COMPRESSION_LEVEL',
        display: shellStringResources.ModelName_CompressionLabel
    })
    public compressionLevel?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'QUOTE_CHAR',
        display: shellStringResources.ModelName_QuoteChar,
        constraint: {
            validator: DelimitedTextDataset.validateQuoteChar
        }
    })
    public quoteChar?: string = fileFormatConstants.quoteCharDefaultForCsv;

    @Metamodel.attribute({
        templatable: true,
        association: 'ESCAPE_CHAR',
        display: shellStringResources.Dataset_FileFormat_EscapeCharFieldLabel
    })
    public escapeChar?: string = fileFormatConstants.escapeCharDefaultForCsv;

    @Metamodel.attribute({
        templatable: true,
        association: 'CHARTOESCAPE_QUOTEESCAPING',
        display: shellStringResources.ModelName_CharToEscapeQuoteEscaping
    })
    public charToEscapeQuoteEscaping?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'FIRSTROW_ASHEADER',
        display: shellStringResources.ModelName_FirstRowAsHeader
    })
    public firstRowAsHeader?: boolean = true;

    @Metamodel.attribute({
        templatable: true,
        association: 'NULL_VALUE',
        display: shellStringResources.NullValueFieldLabel
    })
    public nullValue?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'MULTILINE',
        display: shellStringResources.ModelName_MultiLineRow
    })
    public multiline?: boolean;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }

    private static validateColumnDelimiter(dataset: DelimitedTextDataset): IViolation[] | undefined {
        if (dataset.rowDelimiter === '' && dataset.columnDelimiter !== '') {
            return [{
                message: () => shellStringResources.Dataset_FileFormat_ColumnDelimiterShouldBeNoneError
            }];
        }
        return undefined;
    }

    private static validateQuoteChar(dataset: DelimitedTextDataset): IViolation[] | undefined {
        if (dataset.escapeChar === '' && dataset.quoteChar !== '') {
            return [{
                message: () => shellStringResources.Dataset_FileFormat_QuoteCharShouldBeNoneError
            }];
        }
        return undefined;
    }
}
